module.exports = __webpack_public_path__ + "static/a_z-7208f0ca22579e659503ad1860efd96a.svg";